import { QualityReportForm } from "../components/core/QualityReport/qualityReportForm"


export const QualityReport = ({ history }) => {
    return (
        <>
          <QualityReportForm history={history} />
        </>
      )
}